var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-data-table"},[_c('div',{staticClass:"v-data-table__wrapper"},[_c('table',[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('common.noColumns'))+" ")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }